import React, { FC } from 'react';
import styled from 'styled-components';
import { containsUrl, linkifyAny } from '../utils/linkify';

// Free text with every URL in it clickable (opens in a new tab). Text without a
// URL renders exactly as before; HTML is escaped / sanitized by linkifyAny.
const LinkifiedText: FC<{ value?: string | null }> = ({ value }) => {
  if (value === null || value === undefined || value === '') return null;
  if (!containsUrl(value)) return <Text>{value}</Text>;
  return <Text dangerouslySetInnerHTML={{ __html: linkifyAny(value) }} />;
};

const Text = styled.span`
  min-width: 0;
  overflow-wrap: anywhere;

  a {
    color: var(--primary-700);
    text-decoration: underline;
  }
`;

export default LinkifiedText;
